import React, { useState, useEffect, useRef } from "react";
import "./IconicGallery.css";
import OurCompanies from "../Home/OurCompanies";

import greenland from "../../../src/assets/gallery/greenland.jpg";
import furniture from "../../../src/assets/products/Furniture/6BOeWN4bBXsL0sSlfmS3uG5zGwA5FLLLo1Pv1LP0.jpg";
import motors from "../../../src/assets/motors_images/bus3.jfif";
import shikon from "../../../src/assets/gallery/IconicShikhon.png";
import SuperShop from "../../../src/assets/gallery/Super_shop.png";

import { useNavigate } from "react-router-dom";

const IconicGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  /* =========================================
     CLOSE DROPDOWN OUTSIDE CLICK
  ========================================= */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* =========================================
     COMPANIES
  ========================================= */

  const companies = [
    /* ========================================
       1. ICONIC GREENLAND
    ======================================== */

    {
      id: 1,
      name: "Iconic Greenland",
      category: "real-estate",
      tagline: "Building Dreams, Creating Homes",
      description: "Premium real estate development and property management",
      image: greenland,
      color: "#00C3FF",
      gallerySlug: "greenland",
    },

    /* ========================================
       2. ICONIC SUPER SHOP
    ======================================== */

    {
      id: 2,
      name: "Iconic Super Shop",
      category: "super-shop",
      tagline: "Everything You Need, All in One Place",
      description:
        "A modern retail destination offering everyday essentials, groceries, household products, and quality consumer goods.",
      image: SuperShop,
      color: "#F39C12",
      gallerySlug: "supershop",
    },

    /* ========================================
       3. ICONIC SHIKHON
    ======================================== */

    {
      id: 3,
      name: "Iconic Shikhon",
      category: "education",
      tagline: "Learning Essentials for Every Learner",
      description:
        "A dedicated shop for educational, stationery, office, and learning products designed for students, teachers, and professionals.",
      image: shikon,
      color: "#8E44AD",
      gallerySlug: "shikhon",
    },

    /* ========================================
       4. ICONIC FURNITURE
    ======================================== */

    {
      id: 4,
      name: "Iconic Furniture",
      category: "retail",
      tagline: "Crafting Comfort & Style",
      description: "Exquisite furniture collections for modern living",
      image: furniture,
      color: "#A8763E",
      gallerySlug: "furniture",
    },

    /* ========================================
       5. ICONIC HAJJ
    ======================================== */

    {
      id: 5,
      name: "Iconic Hajj",
      category: "services",
      tagline: "Sacred Journeys, Sacred Trust",
      description: "Premium Hajj and Umrah travel packages and guidance",
      image:
        "https://i.pinimg.com/736x/a7/55/83/a75583a11db54aed125e53531025c54d.jpg",
      color: "#2ECC71",
      gallerySlug: "hajj",
    },

    /* ========================================
       6. ICONIC MOTORS
    ======================================== */

    {
      id: 6,
      name: "Iconic Motors",
      category: "automotive",
      tagline: "Driving Excellence Forward",
      description: "Premium automotive sales and service center",
      image: motors,
      color: "#E74C3C",
      gallerySlug: "motors",
    },
  ];

  /* =========================================
     CATEGORIES
  ========================================= */

  const categories = [
    {
      id: "all",
      name: "All Companies",
      count: companies.length,
    },

    {
      id: "real-estate",
      name: "Iconic Greenland",
      count: companies.filter((c) => c.category === "real-estate").length,
    },

    {
      id: "super-shop",
      name: "Iconic Super Shop",
      count: companies.filter((c) => c.category === "super-shop").length,
    },

    {
      id: "education",
      name: "Iconic Shikhon",
      count: companies.filter((c) => c.category === "education").length,
    },

    {
      id: "retail",
      name: "Iconic Furniture",
      count: companies.filter((c) => c.category === "retail").length,
    },

    {
      id: "services",
      name: "Iconic Hajj",
      count: companies.filter((c) => c.category === "services").length,
    },

    {
      id: "automotive",
      name: "Iconic Motors",
      count: companies.filter((c) => c.category === "automotive").length,
    },
  ];

  /* =========================================
     FILTER COMPANIES
  ========================================= */

  const filteredCompanies =
    selectedCategory === "all"
      ? companies
      : companies.filter((company) => company.category === selectedCategory);

  /* =========================================
     CURRENT CATEGORY NAME
  ========================================= */

  const currentCategoryName =
    categories.find((category) => category.id === selectedCategory)?.name ||
    "All Companies";

  /* =========================================
     OPEN COMPANY GALLERY
  ========================================= */

  const handleOpenGallery = (company) => {
    navigate(`/gallery/${company.gallerySlug}`);
  };

  /* =========================================
     RENDER
  ========================================= */

  return (
    <div className="ga-gallery-container">
      {/* =========================================
          HERO
      ========================================= */}

      <section
        className="ga-hero-section"
        style={{
          position: "relative",
          width: "100%",
          maxHeight: "260px",
          padding: "0px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(135deg, #c004d4 0%, #5b5cff 50%, #00c3ff 100%)",
          overflow: "hidden",
          isolation: "isolate",
        }}
      >
        {/* Left Glow */}
        <div
          style={{
            position: "absolute",
            width: "420px",
            height: "320px",
            left: "-120px",
            top: "-180px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.08) 35%, transparent 70%)",
            filter: "blur(10px)",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />

        {/* Right Glow */}
        <div
          style={{
            position: "absolute",
            width: "500px",
            height: "500px",
            right: "-150px",
            bottom: "-260px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.2) 0%, rgba(0,195,255,0.12) 35%, transparent 70%)",
            filter: "blur(10px)",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />

        {/* Grid */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `
        linear-gradient(
          rgba(255,255,255,0.055) 1px,
          transparent 1px
        ),
        linear-gradient(
          90deg,
          rgba(255,255,255,0.055) 1px,
          transparent 1px
        )
      `,
            backgroundSize: "60px 60px",
            opacity: 0.65,
            pointerEvents: "none",
            zIndex: 1,
          }}
        />

        {/* Content */}
        <div
          style={{
            position: "relative",
            zIndex: 5,
            width: "100%",
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              margin: "0 0 18px",
              color: "#ffffff",
              fontSize: "32px",
              fontWeight: 800,
              lineHeight: 1.15,
              letterSpacing: "-1px",
              textTransform: "uppercase",
              textShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}
          >
            OUR PORTFOLIO OF EXCELLENCE
          </h1>

          <p
            style={{
              width: "100%",
              maxWidth: "720px",
              margin: "0 auto",
              color: "rgba(255,255,255,0.9)",
              fontSize: "clamp(15px, 2vw, 19px)",
              fontWeight: 400,
              lineHeight: 1.7,
              textShadow: "0 2px 12px rgba(0,0,0,0.12)",
            }}
          >
            A diverse ecosystem of businesses united by innovation, quality, and
            trust
          </p>
        </div>
      </section>

      {/* =========================================
          CATEGORY FILTER
      ========================================= */}

      <section className="ga-filter-section">
        <div className="ga-filter-container">
          <div className="ga-filter-header">
            <h3 className="ga-filter-title">BROWSE BY CATEGORY</h3>
          </div>

          <div className="ga-custom-dropdown-wrapper" ref={dropdownRef}>
            {/* SELECTED CATEGORY */}

            <div
              className={`ga-custom-dropdown-selected ${
                isDropdownOpen ? "open" : ""
              }`}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>{currentCategoryName}</span>

              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                style={{
                  transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                <path
                  d="M2.5 4.5L6 8L9.5 4.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {/* DROPDOWN OPTIONS */}

            {isDropdownOpen && (
              <ul className="ga-dropdown-options">
                {categories.map((category) => (
                  <li
                    key={category.id}
                    className={`ga-dropdown-item ${
                      selectedCategory === category.id ? "active" : ""
                    }`}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setIsDropdownOpen(false);
                    }}
                  >
                    <span className="ga-item-name">{category.name}</span>

                    <span className="ga-item-count">({category.count})</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </section>

      {/* =========================================
          COMPANY GRID
      ========================================= */}

      <div className="ga-gallery-grid">
        {filteredCompanies.map((company, index) => (
          <div
            key={company.id}
            className={`ga-gallery-card ${
              hoveredCard === company.id ? "ga-hovered" : ""
            }`}
            onMouseEnter={() => setHoveredCard(company.id)}
            onMouseLeave={() => setHoveredCard(null)}
            style={{
              animationDelay: `${index * 0.1}s`,
            }}
          >
            {/* IMAGE */}

            <div className="ga-card-image-wrapper">
              <img
                src={company.image}
                alt={company.name}
                className="ga-card-image"
              />

              <div
                className="ga-card-overlay"
                style={{
                  background: `linear-gradient(
                    135deg,
                    ${company.color}dd,
                    ${company.color}99
                  )`,
                }}
              ></div>
            </div>

            {/* CONTENT */}

            <div className="ga-card-content">
              <div className="ga-card-header">
                <h3 className="ga-card-title">{company.name}</h3>

                <div
                  className="ga-card-accent"
                  style={{
                    background: company.color,
                  }}
                ></div>
              </div>

              <p className="ga-card-tagline">{company.tagline}</p>

              <p className="ga-card-description">{company.description}</p>

              {/* VIEW GALLERY BUTTON */}

              <button
                type="button"
                className="ga-card-button"
                onClick={() => handleOpenGallery(company)}
                style={{
                  borderColor: company.color,
                  color: company.color,
                }}
              >
                <span>View Gallery</span>

                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6 12L10 8L6 4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* BADGE */}

            <div
              className="ga-card-badge"
              style={{
                background: company.color,
              }}
            >
              <span className="ga-badge-text">ICONIC</span>
            </div>
          </div>
        ))}
      </div>

      {/* =========================================
          OUR COMPANIES
      ========================================= */}

      <div className="ga-our-company">
        <OurCompanies />
      </div>
    </div>
  );
};

export default IconicGallery;
